import React, { useState } from 'react';

export function FieldTooltip({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="fieldTooltipWrap">
      <button
        type="button"
        className="fieldTooltipTrigger"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        aria-label="More information"
      >
        ?
      </button>
      {open && <span className="fieldTooltipPopover">{text}</span>}
    </span>
  );
}
